import Query from '../utils/Query';
import Page from "../models/Page";

export default class PageService {

	static get(lang, slug) {
		return Query.get('/items/page', {
			single: 1,
			fields: '*,content.*',
			filter: {
				slug,
				'content.language': lang,
			}
		}).then(response => new Page(response.data));
	}
}
